import { createAction } from 'redux-actions';

export const startForgotPasswordSubmit = createAction('START_FORGOT_PASSWORD_SUBMIT');

export const resolveForgotPasswordSubmit = createAction('RESOLVE_FORGOT_PASSWORD_SUBMIT');
